import { RootState } from "../../store";

export const selectInvoiceBuilderState = (state: RootState) => state.invoiceBuilder;
export const selectInvoiceBuilderData = (state: RootState) => state.invoiceBuilder.data;
export const selectInvoiceBuilderId = (state: RootState) => state.invoiceBuilder.data.id;
export const selectInvoicePdfGenerating = (state: RootState) => state.invoiceBuilder.pdfGenerating;
export const selectInvoiceClient = (state: RootState) => state.invoiceBuilder.data?.client;
